// export const dev_host = '/api' // 开发环境域名
// export const dev_host = "http://172.23.165.143:9997"; // 开发环境域名
// export const dev_host = "http://f6c8e8a7.natappfree.cc"; // 开发环境域名
export const dev_host = "https://admin.dongfeng-mena.com"; // 开发环境域名
export const product_host = "https://admin.dongfeng-mena.com"; // 生产环境域名
export const IS_DEV = 1; // 0:生产环境 1:开发环境 2:mock环境
const host = IS_DEV == 1 ? dev_host : product_host; // 项目中接口地址host

// export const WEB_SOCKET = `172.23.95.102`; //webSocket地址
export const WEB_SOCKET = `1.95.115.87`; //webSocket地址
export const BASE_URL = `${host}`; // 基础路径
export const UPLOADING_IMAGE = `${host}/api/v1/64803624da6de`; //图片上传路径
// export const API_BASE_URL = IS_DEV == 1 ? `${host}/admin` : `${host}/api`; // 接口请求基础路径
export const API_BASE_URL = `${host}`; // 接口请求基础路径
